export const api = {
    graphqlMaxItemsFetchFallback: 10000,
    graphqlMaxPlayItemsFetch: 500,
    mixRadioCountFetch: 20,
    mixRadioMinFetch: 3
};
